export default __webpack_public_path__ + "static/app-store-download-transparent-0c6cb0a7dc00fb93d99859cdac63dbe8.svg";